import { createAsyncThunk } from "@reduxjs/toolkit";
import { APP_PATH } from "../../api/backendPath";
import axios from "axios";

export const fetchImagingServiceCategories = createAsyncThunk(
  "imagingServices/fetchCategories",
  async (_, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem("usr_1a2b3c");
      const response = await axios.get(
        process.env.REACT_APP_API_URL + APP_PATH.imagingServiceCategories,
        { headers: { Authorization: `Bearer ${token}` } },
      );
      return response.data?.data || [];
    } catch (error) {
      console.error("Failed to fetch imaging service categories:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
